import * as React from 'react';
import { CoherenceNav } from '@coherence-design-system/controls/lib/nav';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { UserEvent, EventType, UsageEventName } from '@micro-frontend-react/employee-experience/lib/UsageTelemetry';
import { useGetPermissions } from '../../Hooks/Common/useGetPermissions';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { INavLinkGroup, INavProps } from './Nav.types';
import { useCoherenceNavGroups } from './useCoherenceNavGroups';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { adminNavConfig, navConfig } from '../../navConfig';

export type PortalPermissions = {
  alias: string,
  upn: string,
  isAdmin: string,
}

export function Nav(props: INavProps): React.ReactElement {
  const { groups, defaultIsNavCollapsed, appName, ...otherProps } = props;
  const [allowedAdmin, setAllowedAdmin] = useState<boolean>(false);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>); 
  const [myPermissions, isMyPermissionsLoading] = useGetPermissions();

  if (!isMyPermissionsLoading && myPermissions.isAdmin !== allowedAdmin) 
    setAllowedAdmin(true);

  const { telemetryClient } = React.useContext(Context as React.Context<IEmployeeExperienceContext>);

  const navGroups: INavLinkGroup[] = allowedAdmin? adminNavConfig : navConfig;
  const coherenceNavGroups = useCoherenceNavGroups(navGroups);

  const onToggle = (isOpen: boolean) => {
    const navigationEvent: UserEvent = {
      subFeature: `Navigation.SideNav.${isOpen ? 'Open' : 'Close'}`,
      type: EventType.User,
      eventName: UsageEventName.LinkClicked,
    };

    telemetryClient.trackEvent(navigationEvent, { ...props });

    if (props.onNavCollapsed) props.onNavCollapsed(isOpen);
  };
  
  return (
    <CoherenceNav
      {...otherProps}
      appName={appName || ''}
      groups={coherenceNavGroups}
      onNavCollapsed={(isOpen: boolean) => onToggle(isOpen)}
      defaultIsNavCollapsed={defaultIsNavCollapsed === undefined ? true : defaultIsNavCollapsed}
      telemetryHook={telemetryClient}
    />
  );
}
